var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobusWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5833 6.91667C13.5833 10.5986 10.5986 13.5833 6.91667 13.5833M13.5833 6.91667C13.5833 3.23477 10.5986 0.25 6.91667 0.25M13.5833 6.91667H0.25M6.91667 13.5833C3.23477 13.5833 0.25 10.5986 0.25 6.91667M6.91667 13.5833C5.20482 11.7859 4.25 9.39884 4.25 6.91667C4.25 4.43449 5.20482 2.04744 6.91667 0.25M6.91667 13.5833C8.62851 11.7859 9.58333 9.39884 9.58333 6.91667C9.58333 4.43449 8.62851 2.04744 6.91667 0.25M0.25 6.91667C0.25 3.23477 3.23477 0.25 6.91667 0.25",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobusWhite);
export default __webpack_public_path__ + "static/media/globusWhite.739cce5a4784a7f305bb281175aeecda.svg";
export { ForwardRef as ReactComponent };